<template>
    <div :style="el.getStyleOnlyPosition(currentElementIndex)" :class="el.getAnimationClass(currentElementIndex)" @mousedown="eventDrag($event, el.previewId)"
    class="video-container trigger-container">
        <div :style="el.getStyle(currentElementIndex)">
            <video :style="el.getVideoStyle()" :src="el.Path" autoplay loop muted></video>
        </div>
        <div class="shadow-select"></div>
        <div class="trigger-left" @mousedown="eventResize($event, el.previewId, 'left')"></div>
        <div class="trigger-right" @mousedown="eventResize($event, el.previewId, 'right')"></div>
        <div class="trigger-top" @mousedown="eventResize($event, el.previewId, 'top')"></div>
        <div class="trigger-bottom" @mousedown="eventResize($event, el.previewId, 'bottom')"></div>
        <div class="trigger-top-left" @mousedown="eventResize($event, el.previewId, 'top-left')"></div>
        <div class="trigger-top-right" @mousedown="eventResize($event, el.previewId, 'top-right')"></div>
        <div class="trigger-bottom-left" @mousedown="eventResize($event, el.previewId, 'bottom-left')"></div>
        <div class="trigger-bottom-right" @mousedown="eventResize($event, el.previewId, 'bottom-right')"></div>
    </div>
</template>

<script>
import BasePreviewComponents from "./base/basePreviewComponents.vue";
export default {
    name: 'VideoMedia',
    extends: BasePreviewComponents,
    methods: {
    }
}
</script>

<style scoped>
video {
    pointer-events: none;
}

.shadow-select {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom: 0;
    opacity: 0;
    transition: all 0.5s ease;
    box-shadow: inset 0 0 20px 10px rgba(59, 130, 246,1);
    pointer-events: none;
}

.trigger-container.selected .shadow-select {
    opacity: 1;
}
</style>